import $ from 'jquery';


export function bindJumpToWizardLinks(){
  $(document).on("click", '[data-refresh-to-target-form]', handleRefreshWithQueryKey);
}



function handleRefreshWithQueryKey(e){
  e.preventDefault();
  const link = $(this);
  const newUrl = generateNewUrlFromLink(link);
  window.location = newUrl;
}

function generateNewUrlFromLink(link){
  let targetStr = link.data('refresh-to-target-form');
  let href = link.attr('href');
  let idx = href.indexOf('?');
  let domainAndPath = href.substring(0, idx);
  let queryStr = href.substring(idx+1);
  let queryObj = $.deparam(queryStr);
  queryObj.jumptowizardtab = targetStr;
  queryStr = $.param(queryObj);

  return domainAndPath + "?" + queryStr
}


export function handleQueryParamTraversalToWizardTab(wizard){
  let queryStr = window.location.search.substring(1);
  let queryObj = $.deparam(queryStr);
  let targetForm = wizard.getWizardElement().find(queryObj.jumptowizardtab);
  if(targetForm.length){
    wizard.gotToForm(targetForm);
  } 
}


// WEBPACK FOOTER //
// ./src/utilities/jumpToWizardLogic/index.js